module.exports = __webpack_public_path__ + "img/background.79628518.jpg";